// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_4ob","credits":"e_5ob","badgeContainer":"e_6ob","badge":"e_7ob"};